module.exports = __webpack_public_path__ + "img/firehawk_sport.25e44508.png";